import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAdminAuth } from './stores/auth'

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/orgs' },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('./layouts/AdminLayout.vue'),
    children: [
      { path: 'orgs', name: 'orgs', component: () => import('./views/Organizations.vue') },
      {
        path: 'orgs/:orgId',
        name: 'org-detail',
        component: () => import('./views/OrganizationDetail.vue'),
      },
      { path: 'audit', name: 'audit', component: () => import('./views/Audit.vue') },
      { path: 'security', name: 'security', component: () => import('./views/Security.vue') },
      { path: 'dev/workers', name: 'dev-workers', component: () => import('./views/DevWorkers.vue') },
      { path: 'dev/d1', name: 'dev-d1', component: () => import('./views/DevD1.vue') },
      { path: 'dev/kv', name: 'dev-kv', component: () => import('./views/DevKv.vue') },
      { path: 'dev/queues', name: 'dev-queues', component: () => import('./views/DevQueues.vue') },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('./views/NotFound.vue'),
    meta: { public: true },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  const auth = useAdminAuth()
  if (!auth.ready) await auth.init()
  if (to.meta.public) return true
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  return true
})
